import React from "react";
import EntityEmptyPage from "components/Records/NewRecordPages/EntityEmptyPage";
import AddFlyersPopup from "./AddFlyersPopup";


interface FlyersEmptyPageProps {
  onFlyersCreated?: (newFlyers: any) => void;
}


export default function FlyersEmptyPage({
  onFlyersCreated,
}: FlyersEmptyPageProps) {
  return (
    <EntityEmptyPage
      title="Flyers"
      colorKey="interactions"
      AddPopupComponent={AddFlyersPopup}
      onEntityCreated={onFlyersCreated}
      items={[
        {
          id: "select",
          type: "text",
          text: "Select a Flyers",
          direction: "left",
        },
        {
          id: "create",
          type: "button",
          label: "Create New Flyers",
          openPopup: true, 
        },
        {
          id: "send",
          type: "text",
          text: "Send Flyers",
          direction: "right",
        },
        {
          id: "details",
          type: "text",
          text: "View Flyers History",
          direction: "down",
        },
      ]}
    />
  );
}
